import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=43cf5acc&"
import script from "./Locale.vue?vue&type=script&lang=js&"
export * from "./Locale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43cf5acc')) {
      api.createRecord('43cf5acc', component.options)
    } else {
      api.reload('43cf5acc', component.options)
    }
    module.hot.accept("./Locale.vue?vue&type=template&id=43cf5acc&", function () {
      api.rerender('43cf5acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/components/Locale.vue"
export default component.exports